<template>
<div>
    <v-card dark class="pa-4 grey darken-3 ma-4">
        <v-toolbar dark flat dense class="grey darken-3">
            <v-toolbar-title>Продаж Megogo Епіцентр</v-toolbar-title>
        </v-toolbar>
        <v-card-text v-if="f.id">
            <v-flex xs4 lg1>
                <v-text-field v-model="f.id" label="ID користувача" readonly></v-text-field>
            </v-flex>
            <v-flex xs12 lg6>
                <v-text-field v-model="f.fio" label="ПІБ користувача" readonly></v-text-field>
            </v-flex>
            <v-flex xs12 lg6>
                <v-text-field v-model="f.phone" label="Телефон користувача" readonly></v-text-field>
            </v-flex>
            <v-flex xs12 lg6>
                <v-text-field v-model="f.contractor" label="Контрагент користувача" readonly></v-text-field>
            </v-flex>
            <v-flex xs12 lg6>

            </v-flex>
            <v-subheader>Сформувати документи по проданим пакетам Megogo</v-subheader>
            <v-flex xs12 lg6>
                <v-toolbar dark flat dense class="grey darken-3 ma-4">
                    <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="dateFrom" label="Дата з" append-icon="mdi-calendar" v-on="on" hide-details readonly clearable></v-text-field>
                        </template>
                        <v-date-picker v-model="dateFrom" @input="menu1 = false"></v-date-picker>
                    </v-menu>
                    <v-spacer></v-spacer>
                    <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="dateTo" label="Дата по" append-icon="mdi-calendar" v-on="on" hide-details readonly clearable></v-text-field>
                        </template>
                        <v-date-picker v-model="dateTo" @input="menu2 = false"></v-date-picker>
                    </v-menu>
                </v-toolbar>
            <v-data-table :headers="headers" item-key="code" :items="list" :footer-props="footerProps" class="ma-4">
                <template v-slot:no-data>
                    ...
                </template>
            </v-data-table>

            </v-flex>
        </v-card-text>
        <v-card-actions>
            <v-btn text color="grey" @click="goBack()">
                <v-icon color="grey">mdi-keyboard-return</v-icon> Повернутись
            </v-btn>
            <v-btn text v-if="list.length" color="megogo" @click="sendForm()">
                Сформувати документ Тайфун
            </v-btn>
        </v-card-actions>

    </v-card>
    <v-dialog v-model="successB" max-width="500">
        <v-card>
            <v-system-bar>
                <v-spacer></v-spacer>
                <v-icon @click="successB = false">mdi-close</v-icon>
            </v-system-bar>
            <v-card-text>
                <h5>Успішно сформовано документи!</h5>
                <div>За 2 сек. буде проізведено перехід на картку історії продажу</div>
            </v-card-text>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import {
    ValidationObserver,
    ValidationProvider
} from "vee-validate"

import {
    mapActions
} from 'vuex'

import {
    mask
} from "vue-the-mask"

export default {
    components: {
        ValidationProvider,
        ValidationObserver
    },
    directives: {
        mask
    },
    data() {
        return {
            dateFrom: null,
            dateTo: null,
            menu1: null,
            menu2: null,
            f: {
                id: 2330
            },
            usersTable: false,
            search: '',
            shops: [],
            successB: false,
            userData: {},
            footerProps: {
                'items-per-page-options': [10, 20],
                'items-per-page-text': 'на стор.'
            },
            headers: [{
                    text: 'Пакет',
                    align: 'left',
                    sortable: true,
                    value: 'service_type',
                    selected: true,
                    width: '10%',
                },
                {
                    text: 'Дата продажу',
                    align: 'left',
                    sortable: true,
                    value: 'sales_date',
                    selected: true,
                    width: '20%',
                },

            ]
        }
    },
    methods: {
        ...mapActions(['setSnackbar', 'touch', 'getMemberData', 'createTyphoonDocuments','getEpicentrkMegogoSoldCodes']),
        goBack() {
            window.history.state ? this.$router.go(-1) : this.$router.push('/adminpanel')
        },
        getUsers() {
            this.usersTable = true
            this.getDataFromApi()
        },
        getDataFromApi() {},
        fillCard() {
            this.usersTable = false
            this.getMemberData(2330)
                .then(data => {
                    this.shops = data.shops || []
                    this.userData = data.userData || {}
                    this.f = {
                        id: data.userData.id,
                        fio: `${data.userData.firstname} ${data.userData.surname}`,
                        phone: data.userData.phone,
                        contractor: data.userData.contractorName,
                        contractor_id: data.userData.contractor
                    }
                })
        },
        sendForm() {
            const data = {
                ids: this.list.map(el => el.id),
                ...this.f
            }
            this.createTyphoonDocuments(data)
                .then(data => {
                    if (data.error) {
                        this.setSnackbar(['error', data.error])
                    } else {
                        this.successB = true
                        this.getEpicentrkMegogoSoldCodes()
                        if (data.historyId){
                            setTimeout(() => {
                                this.openCard(data.historyId)    
                            }, 2000);
                        }
                    }
                })
                .catch(error => console.error(error))
        },
        openCard(id) {
            this.$router.push('/adminpanel/epicentrk-megogo-package-selling-history/'+id)
        },

    },
    created() {
        this.fillCard()
        this.getEpicentrkMegogoSoldCodes()
    },
    computed: {
        list() {
            const list = this.$store.state.adminpanel.epicentrkMegogoSoldCodesList
            return list.filter(el => {
                        const value = el.sales_date
                        if (!this.dateFrom && !this.dateTo) return true
                        const lDate = new Date(value)
                        const fromDate = this.dateFrom ? new Date(this.dateFrom) : new Date('2000-01-01')
                        const toDate = this.dateTo ? new Date(this.dateTo) : new Date()
                        return lDate >= fromDate && lDate <= toDate

            })
        },
    },
    watch: {}
}
</script>

<style>
.inp-cnt {
    color: black;
    margin-left: 3px;
    margin-right: 3px;
    border: 1px solid rgb(7, 0, 0);
    width: 40px;
    text-align: center;
    padding: 1px;
    border-radius: 4px;
    box-sizing: border-box;
    background: #ffffff;
}
</style>
